
import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {User} from '../../shared/models/user';
import {NbButtonModule, NbDialogRef} from '@nebular/theme';
import {ValetService} from '../../valet/services/valet.service';
import {UpdateUser} from '../../shared/store/user/auth.actions';
import {Store} from '@ngrx/store';
import {UserState} from '../../shared/store/user/auth.state';
import { CommonCardComponent } from '../common-card/components/common-card/common-card.component';
import { CommonCardBodyComponent } from '../common-card/components/common-card-body/common-card-body.component';
import { CommonCardHeaderComponent } from '../common-card/components/common-card-header/common-card-header.component';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'pv-common-first-connection-dialog',
    templateUrl: './common-first-connection-dialog.component.html',
    styleUrls: ['./common-first-connection-dialog.component.scss'],
    imports: [
    CommonCardComponent,
    CommonCardBodyComponent,
    CommonCardHeaderComponent,
    TranslateModule,
    NbButtonModule
]
})
export class CommonFirstConnectionDialogComponent implements OnInit {
  @Input() valet: User;
  @Output() submitEvent = new EventEmitter();

  constructor(protected dialogRef: NbDialogRef<CommonFirstConnectionDialogComponent>,
              private store: Store<UserState>,
              private valetService: ValetService) { }

  ngOnInit(): void {
  }

  understoodValidation() {
    this.valetService.validateFirstConnection().then(res => {
      this.store.dispatch(new UpdateUser(res));
      this.dialogRef.close();
    })
  }
}
